/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import DbBaseObject from '@shared/DbBaseObject.js';
import dayjs from 'dayjs'
import {uuidv4} from "@/utils/helpers";
import {BillingType} from "@/core/js/model/Billing/BillingData";

export const MilestoneType = Object.freeze({
	NONE: "NONE",
	RECURRING: "RECURRING",
	PROGRESS: "PROGRESS",
	DATE: "DATE",
})

export const PaymentStatus = Object.freeze({
	NONE: "NONE",
	TEMP: "TEMP",
	INVOICED: "INVOICED",
	CONFIRM_PENDING: "CONFIRM_PENDING",
	PAID: "PAID",
	PARTIALLY_PAID: "PARTIALLY_PAID",
	DELETED: "DELETED",
	REFUNDED: "REFUNDED",
})

export default class BillingItem extends DbBaseObject{

	type: string = "BillingItem"

	amount: number = 0
	name: string = ""

	additionalNote: string = ""

	billingType: BillingType = BillingType.FIXED


	milestoneType: MilestoneType = MilestoneType.NONE;
	milestoneSectionId: string = "";
	milestoneTs: number = 0;


	// coachingProgramId: string = ""


	durationMs: number = 0
	startDateMs: number = new Date().getTime()

	constructor(amount, name, billingType) {
		super();
		this.id = uuidv4();
		this.billingType = billingType || BillingType.FIXED;
		this.amount = amount || 0
		this.name = name || ""
	}


	isDueDateSet(){
		return this.milestoneType && this.milestoneType !== MilestoneType.NONE
	}

	paidOrInvoicedDateFormatted(){
		if(this.isPaid()){
			return this.paidDateFormatted()
		}
		if(this.isInvoiced()){
			return this.invoicedDateFormatted()
		}
	}



	milestoneDateFormatted(){
		return dayjs(this.milestoneTs).format("MMM DD, YYYY")
	}

	durationFormatted(){
		let hours = Math.floor(this.durationMs / (60 * 60 * 1000))
		let minutes = Math.floor(this.durationMs / (60 * 1000) % 60)
		minutes = minutes < 10 ? "0" + minutes : minutes
		let res = hours + ":" + minutes
		return res
	}


	isFixed(){
		return this.billingType === BillingType.FIXED
	}

	get isHourly(){
		return this.billingType === BillingType.HOURLY
	}

	set isHourly(val){
		if(val){
			this.billingType = BillingType.HOURLY
		} else {
			this.billingType = BillingType.FIXED
		}
	}


	get startDateObj(){
		return dayjs(this.startDateMs).toDate()
	}
	set startDateObj(val){
		this.startDateMs = val.getTime()
	}

	isBillingItemSetup(){
		if(!this.milestoneType || this.milestoneType === MilestoneType.NONE){
			return false
		}
		let res = false

		switch (this.milestoneType){
			case MilestoneType.PROGRESS:
				if(this.milestoneSectionId && this.amount){
					res = true
				}
				break;
		}

		return res
	}

	resetItem(){
		this.milestoneType = MilestoneType.NONE
		this.name = ""
		this.milestoneSectionId = ""
	}


}



